// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDAkO_jsr_fvI_8uTDjUMhuuMW7uaugSNk",
  authDomain: "sitrepnow-b51ca.firebaseapp.com",
  projectId: "sitrepnow-b51ca",
  storageBucket: "sitrepnow-b51ca.firebasestorage.app",
  messagingSenderId: "646818295374",
  appId: "1:646818295374:web:be22c50360c1e7ea3e5d1f",
  measurementId: "G-J9XSWVHJQD"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
